import fetchPosts from '../fetch/fetch-posts'
import { ARCHIVE_BUTTON, ARCHIVE_TAX_SLUG, ARCHIVE_PARENT_TAX_SLUG } from '../constants'

export default function taxonomyFilter (archive) {
    const filterButtons = archive.querySelectorAll(`[${ARCHIVE_BUTTON}]`)

    if (filterButtons.length > 0) {
        filterButtons.forEach(button => button.addEventListener('click', () => {
            const taxSlug = button.getAttribute(ARCHIVE_TAX_SLUG)
            const categoryParent = button.closest(`[${ARCHIVE_PARENT_TAX_SLUG}="${taxSlug}"]`)
            const activeSub = categoryParent.querySelectorAll('.mtt-archive-category--sub.active')
            const openButton = categoryParent.querySelectorAll('.has-children.open')

            if (button.classList.contains('has-children')) {
                const children = button.closest('li').querySelector('.mtt-archive-category--sub')
                if (children) {
                    if (button.classList.contains('open')) {
                        button.classList.remove('open')
                        children.classList.remove('active')
                    } else {
                        button.classList.add('open')
                        children.classList.add('active')
                    }
                }
            }

            if (!button.classList.contains('child-button')) {
                if (activeSub) {
                    for (let i = 0; i < activeSub.length; i++) {
                        const sub = activeSub[i]
                        sub.classList.remove('active')
                    }
                }
                if (openButton) {
                    for (let i = 0; i < openButton.length; i++) {
                        const button = openButton[i]
                        button.classList.remove('open')
                    }
                }
            }

            if (!categoryParent) {
                return
            }

            if (button.getAttribute('data-term-id')) {
                // Get active button
                const activeButton = categoryParent.querySelector(`.active[${ARCHIVE_TAX_SLUG}]`)
                // Change active class on buttons
                activeButton.classList.remove('active')
                button.classList.add('active')
                // Fetch posts
                fetchPosts(archive, button)
            }
        }))
    }
}
